import { configureStore } from "@reduxjs/toolkit";
import LoginSessionData from "./login/LoginStore";
import AdminDashboardData from "./admin/AdminDashboardStore";
import StudentUploadData from "./admin/StudentDataUploadStore";
import EvaluatordData from "./evaluator/EvaluatorStore";
import ModalToShow from "./ModalToShow";

export const store = configureStore({
  reducer: {
    loginSessionData: LoginSessionData,
    adminDashboardData: AdminDashboardData,
    studentUploadData: StudentUploadData,
    evaluatordData: EvaluatordData,
    modalToShow: ModalToShow,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
